export default __webpack_public_path__ + "static/media/rules-and-regulations.aab8a4c6.svg";